import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'inTier',
  pure: false,
})
export class InTierPipe<T extends { priceTierId: string }>
  implements PipeTransform
{
  transform(items: T[], tier: string): T[] {
    if (!items || !tier) {
      return [];
    }

    return items.filter((item) => item.priceTierId === tier);
  }
}
